import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Purchases from "@/pages/Purchases";
import NewSale from "@/pages/NewSale";
import Invoices from "@/pages/Invoices";
import InvoiceView from "@/pages/InvoiceView";
import Customers from "@/pages/Customers";
import Vendors from "@/pages/Vendors";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Accounts from "@/pages/Accounts";
import Expenses from "@/pages/Expenses";

function Protected({ children, ownerOnly }) {
  const { user, ready, isOwner } = useAuth();
  const loc = useLocation();
  if (!ready) return <div className="min-h-screen grid place-items-center text-[#8C929B]">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (ownerOnly && !isOwner) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/purchases" element={<Purchases />} />
              <Route path="/sales/new" element={<NewSale />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/invoices/:id" element={<InvoiceView />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/expenses" element={<Expenses />} />
              <Route path="/accounts" element={<Protected ownerOnly><Accounts /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
              <Route path="/settings" element={<Protected ownerOnly><Settings /></Protected>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
